import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getImageUrl } from '../lib/imageUrls';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  /** When true, prevents indexing (for locked/sensitive pages) */
  noindex?: boolean;
}

export const SEO: React.FC<SEOProps> = ({
  title = "Bes Bujupi – Designer & Creative Leader",
  description = "Creative Director & design leader Bes Bujupi. Brand building, product design, 3D/AR experiences. Clients: Volvo, Nike, Formula 1, Nissan. 20+ years. Gothenburg.",
  image,
  url = "https://bes.art",
  type = "website",
  noindex = false,
}) => {
  const siteTitle = title.includes("Bes Bujupi") ? title : `${title} – Bes Bujupi`;
  // Transform image URL if it's a local path, otherwise use as-is
  // Default to the S3/CloudFront image for social media sharing (uses same base as getImageUrl)
  const imageUrl = image ? getImageUrl(image) : getImageUrl("/_images/bb25.jpg");
  const robotsContent = noindex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsContent} />
      
      {/* Open Graph tags */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}; 